// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3dBsn","title":"Info_title__TgVs5","links":"Info_links__qXB8p","link":"Info_link__mj8zV","logo":"Info_logo__1J-nV"};